
<div class="flex items-center justify-center min-h-full p-4">
  <div class="w-full max-w-md">
    <div class="text-center mb-8">
       <h1 class="text-3xl font-extrabold text-white font-brand tracking-wider">
        <i class="fa-solid fa-key mr-2 text-emerald-400"></i>
        Forgot Password
      </h1>
      <p class="text-slate-400 mt-2 text-sm">กู้คืนรหัสผ่านของคุณ</p>
    </div>

    <div class="bg-slate-800/80 backdrop-blur-sm shadow-2xl rounded-2xl p-8 border border-slate-700">
      
      @if (message(); as msg) {
        <div class="mb-6 p-4 rounded-lg text-sm border flex items-start gap-3"
             [class]="msg.type === 'success' ? 'bg-emerald-900/50 border-emerald-500 text-emerald-200' : 'bg-red-900/50 border-red-500 text-red-200'">
            <i class="fa-solid" [class]="msg.type === 'success' ? 'fa-check-circle' : 'fa-circle-exclamation'"></i>
            <span>{{ msg.text }}</span>
        </div>
      }

      <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
        <div class="space-y-6">
          <div>
            <label for="email" class="block text-sm font-medium text-slate-300 mb-1">อีเมล (Email Address)</label>
            <div class="relative">
              <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-500">
                  <i class="fa-solid fa-envelope"></i>
              </span>
              <input formControlName="email" id="email" type="email" required
                class="w-full bg-slate-900 border border-slate-600 rounded-lg py-3 pl-10 pr-3 text-slate-200 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all placeholder-slate-600"
                placeholder="name@example.com">
            </div>
            @if(resetForm.get('email')?.invalid && resetForm.get('email')?.touched) {
                <p class="text-red-400 text-xs mt-1">กรุณากรอกอีเมลให้ถูกต้อง</p>
            }
          </div>

          <button type="submit" [disabled]="resetForm.invalid || isLoading()"
            class="w-full flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-3.5 rounded-lg shadow-lg transition-all disabled:bg-slate-600 disabled:cursor-not-allowed">
            @if (isLoading()) {
              <i class="fa-solid fa-spinner animate-spin"></i>
              <span>Sending...</span>
            } @else {
              <span>ส่งลิงก์รีเซ็ต (Send Link)</span>
            }
          </button>
        </div>
      </form>
    </div>

     <div class="text-center mt-6">
        <a routerLink="/login" class="text-slate-400 hover:text-white transition-colors text-sm font-semibold">
            <i class="fa-solid fa-arrow-left mr-1"></i> กลับไปหน้าล็อกอิน (Back to Login)
        </a>
    </div>
  </div>
</div>
